module.exports = __webpack_public_path__ + "static/media/stairs.c8b8b463.png";